import React from 'react';

const CustomerForm = ({
  showForm,
  editingCustomer,
  customerForm,
  onFormChange,
  onSubmit,
  onCancel
}) => {
  if (!showForm) return null;

  return (
    <div className="mb-8">
      <div className="card">
        <div className="p-6">
          <h3 className="text-lg font-semibold mb-4">
            {editingCustomer ? 'Edit Customer' : 'Add New Customer'}
          </h3>
          <form onSubmit={onSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="form-group">
                <label className="form-label">First Name *</label>
                <input
                  type="text"
                  value={customerForm.firstName}
                  onChange={(e) => onFormChange({...customerForm, firstName: e.target.value})}
                  className="input"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Last Name *</label>
                <input
                  type="text"
                  value={customerForm.lastName}
                  onChange={(e) => onFormChange({...customerForm, lastName: e.target.value})}
                  className="input"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="form-group">
                <label className="form-label">Email *</label>
                <input
                  type="email"
                  value={customerForm.email}
                  onChange={(e) => onFormChange({...customerForm, email: e.target.value})}
                  className="input"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Phone *</label>
                <input
                  type="tel"
                  value={customerForm.phone}
                  onChange={(e) => onFormChange({...customerForm, phone: e.target.value})}
                  className="input"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Address *</label>
              <input
                type="text"
                value={customerForm.address}
                onChange={(e) => onFormChange({...customerForm, address: e.target.value})}
                className="input"
                required
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="form-group">
                <label className="form-label">City *</label>
                <input
                  type="text"
                  value={customerForm.city}
                  onChange={(e) => onFormChange({...customerForm, city: e.target.value})}
                  className="input"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">State *</label>
                <input
                  type="text"
                  value={customerForm.state}
                  onChange={(e) => onFormChange({...customerForm, state: e.target.value})}
                  className="input"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">ZIP Code *</label>
                <input
                  type="text"
                  value={customerForm.zipCode}
                  onChange={(e) => onFormChange({...customerForm, zipCode: e.target.value})}
                  className="input"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="form-group">
                <label className="form-label">Property Type</label>
                <select
                  value={customerForm.propertyType}
                  onChange={(e) => onFormChange({...customerForm, propertyType: e.target.value})}
                  className="input"
                >
                  <option value="residential">Residential</option>
                  <option value="commercial">Commercial</option>
                  <option value="industrial">Industrial</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Property Size</label>
                <input
                  type="text"
                  value={customerForm.propertySize}
                  onChange={(e) => onFormChange({...customerForm, propertySize: e.target.value})}
                  className="input"
                  placeholder="e.g., 0.5 acres"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="form-group">
                <label className="form-label">Preferred Contact</label>
                <select
                  value={customerForm.preferredContact}
                  onChange={(e) => onFormChange({...customerForm, preferredContact: e.target.value})}
                  className="input"
                >
                  <option value="email">Email</option>
                  <option value="phone">Phone</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Status</label>
                <select
                  value={customerForm.status}
                  onChange={(e) => onFormChange({...customerForm, status: e.target.value})}
                  className="input"
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                  <option value="prospect">Prospect</option>
                  <option value="archived">Archived</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Notes</label>
              <textarea
                value={customerForm.notes}
                onChange={(e) => onFormChange({...customerForm, notes: e.target.value})}
                className="input"
                rows="3"
                placeholder="Additional notes about the customer..."
              />
            </div>

            <div className="flex space-x-3">
              <button type="submit" className="btn-primary">
                {editingCustomer ? 'Update' : 'Create'} Customer
              </button>
              <button
                type="button"
                onClick={onCancel}
                className="btn-secondary"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CustomerForm;